import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import { Configuration } from '@shared/models/configuration';
import { Go } from '@shared/store/actions/router-extension.action';
import { RouteState } from '@shared/store/reducers/route-extension.reducers';


@Injectable({providedIn: 'root'})
export class AppNavigationService {

  constructor (private route: ActivatedRoute, private routeStore: Store<RouteState>, private router: Router) {
    /*router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        // Init Code
      }

      if (e instanceof NavigationEnd) {
        // Exit Code
      }
    });*/
  }

  resolveAppToAppRoute (projectStore: Store<any>, InvokeLoadProjectByProjectIdAction: any) {
    const projectId = this.getUrlParam('projectId');
    const appRelativeUrl = this.getUrlParam('appRelativeUrl');
    if (projectId) {
      InvokeLoadProjectByProjectIdAction.projectId = projectId;
      if (appRelativeUrl) {
        InvokeLoadProjectByProjectIdAction.appRelativeUrl = appRelativeUrl;
        projectStore.dispatch(InvokeLoadProjectByProjectIdAction);
      } else {
        projectStore.dispatch(InvokeLoadProjectByProjectIdAction);
      }
    } else {
      if (appRelativeUrl) {
        this.routeStore.dispatch(new Go({path: [appRelativeUrl]}));
      }
    }
  }

  getUrlParam (name): string {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || '0';
    }
  }
}


